export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q05_b.90f3aeac.png";